<template>
  <a id="newsBox" class="box" :href="newsItemLink(item)">
    <div class="title">{{ item.title }}</div>
    <div class="details mt-auto">
      {{ item.author }} <span class="dot-separator">&#8226;</span>
      {{ formatDate(item.date) }}
    </div>
    <img :src="item.image" class="poster" />
    <div class="icon" v-if="didsymbolsDataReceived">
      <img
        v-for="symbol in item.symbols"
        :key="symbol"
        :src="getSymbolImageSrc(symbol)"
        class="img-responsive"
      />
    </div>
  </a>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "CardNews",
  props: {
    item: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapState(["lang", "webInfo", "symbolsData"]),
    ...mapGetters(["getSymbolImageSrc"]),
    didsymbolsDataReceived() {
      return Object.keys(this.symbolsData).length !== 0;
    }
  },
  methods: {
    formatDate(date) {
      moment.locale(this.lang);
      const dateAsCETtz = moment(date + "+01:00"); //treat the hard coded time as if it is CET +1
      return (
        dateAsCETtz.startOf("hour").fromNow() +
        ", " +
        dateAsCETtz.format("DD MMM, HH:mm")
      );
    },
    newsItemLink(item) {
      return `${this.webInfo.getFullHostWithProtocol()}/plus/news/${item.friendly_url}`; //relative link isn't possible. this component is sometime displayed as part of instruments page
    }
  }
};
</script>
<style lang="scss" scoped>
#newsBox {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  .details {
    position: relative;
    display: flex;
    align-items: center;
    font-size: 0.75rem;
    margin-bottom: 0.625rem;
    color: #9e9e9e;
    .dot-separator {
      margin-left: 5px;
      margin-right: 5px;
    }
  }
  .poster {
    max-width: 100%;
    width: 18.63rem;
    height: 11.25rem;
    align-self: baseline;
  }
  .icon {
    margin-top: 0.75rem;
    display: flex;
    img {
      width: 1.125rem;
      height: 1.125rem;
      margin-right: 0.625rem;
    }
  }
  .img-or-video {
    position: relative;
    width: 18.5rem;
    height: 13.75rem;
    margin: 0.75rem auto 0;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
  .assetsList {
    display: flex;
    align-items: center;
    height: 1.125rem;
    margin-top: 0.75rem;

    img {
      min-width: 1.125rem;
      height: 100%;
      margin-left: 0.625rem;
      &:first-child {
        margin-left: 0;
      }
    }
  }
}
.ar {
  #newsBox {
    .icon {
      img {
        margin: 0 0 0 0.625rem;
      }
    }
    .assetsList {
      img {
        margin: 0 0.625rem 0 0;
        &:first-child {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
